<template>
  <el-dialog :visible.sync="visible" width="50%">
    <p class="title">{{ language == 'zh' ? '询价咨询' : 'REQUEST FOR A FREE QUOTATION' }}</p>
    <el-form
      :label-position="labelPosition"
      label-width="80px"
      :model="formLabelAlign"
      :rules="rules"
      ref="ruleForm"
    >
      <div class="firststep" v-if="step == 1">
        <p class="tip_big">
          {{
            language == 'zh' ? '感谢您对海德贝思液压的支持，请在下方留下您的联系方式和咨询内容，我们将尽快与您联系！' : 'Appreciated for your interest in HydraBase. Please kindly provide your contact information and leave message below. we will contact you as soon as possible.'
          }}</p>
        <p class="tip_small">
          {{ language == 'zh' ? '所有带*的选项为必填项' : '( * ) Marked with an asterisk are required fields.' }}</p>
        <el-row :gutter="100">
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item :label="language == 'zh'?'姓名':'Name'" class="text" prop="name">
              <el-input v-model="formLabelAlign.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12"
          >
            <el-form-item :label="language == 'zh'?'电话':'Tel.'" prop="tel">
              <el-input v-model="formLabelAlign.tel"></el-input>
            </el-form-item
            >
          </el-col>
        </el-row>
        <el-row :gutter="100">
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item :label="language == 'zh'?'公司':'Company'" prop="company">
              <el-input v-model="formLabelAlign.company"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12"
          >
            <el-form-item :label="language == 'zh'?'职位':'Role in the company'" prop="title">
              <el-input v-model="formLabelAlign.title"></el-input>
            </el-form-item
            >
          </el-col>
        </el-row>
        <el-row :gutter="100">
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item :label="language == 'zh'?'邮箱':'Email'" prop="email">
              <el-input v-model="formLabelAlign.email"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12"
          >
            <el-form-item :label="language == 'zh'?'国家':'Country'" prop="country">
              <el-input v-model="formLabelAlign.country"></el-input>
            </el-form-item
            >
          </el-col>
        </el-row>
        <el-form-item :label="language == 'zh'?'留言':'Message'" prop="message">
          <el-input v-model="formLabelAlign.message" type="textarea"
                    :placeholder="language == 'zh'?'300字以内':'Max. 300 words'"
                    :rows="rows"></el-input>
        </el-form-item>
      </div>
    </el-form>
    <el-row style="margin-top:5rem;">
      <!--      <el-col :xs="8" :sm="8" :md="8" :lg="3">-->
      <!--        <p class="jobBtn" @click="step = 2" v-if="step == 1">{{language == 'zh'?'下一页':'Next'}}</p>-->
      <!--        <p class="jobBtn"  @click="step = 1" v-if="step == 2">{{language == 'zh'?'上一页':'Previous'}}</p>-->
      <!--      </el-col>-->
      <el-col :xs="8" :sm="8" :md="8" :lg="19">
        <el-upload
          class="upload-demo"
          :action="action"
          multiple
          :on-remove="onRemove"
          :on-progress="onProgress"
          :on-success="onSuccess">
          <el-button class="jobBtn" :loading="loading">{{
              language == 'zh' ? '上传附件' : 'Upload document'
            }}
          </el-button>
        </el-upload>
      </el-col>
      <el-col :xs="8" :sm="8" :md="8" :lg="2">
        <el-button :loading="loading" class="jobBtn" @click="submit()">{{
            language == 'zh' ? '提交' : 'Submit'
          }}
        </el-button>
      </el-col>
    </el-row>

  </el-dialog>
</template>
<script>
import qs from 'qs'

export default {
  props: {
    id: {
      type: String,
      default: "",
    },
    language: {
      type: String,
      default: ''
    },
    // job: {
    //   type: Object,
    //   default: {}
    // },
  },
  computed: {
    rules() {
      return {
        name: [
          {
            required: true,
            message: this.language == 'zh' ? '请输入姓名' : 'Please fill in your name.',
            trigger: 'blur'
          },
        ],
        company: [
          {required: false, message: '请输入公司名称', trigger: 'change'},
          // { message: '请输入数字', type:'number' },
          // { message: '最多输入两位数字', min:2,max:2 , trigger: 'blur'},
        ],
        title: [
          {required: false, message: '请输入职位', trigger: 'blur'}
        ],
        tel: [
          {
            required: true,
            message: this.language == 'zh' ? '请输入电话' : 'Please fill in your contact number.',
            trigger: 'blur'
          },
          { type: 'number', message: this.language == 'zh' ? '请输入电话' : 'Please fill in your contact number.', trigger: 'change' }
        ],
        email: [
          {required: false, message: '请输入邮箱', trigger: 'blur'}
        ],
        country: [
          {required: false, message: '请输入国家', trigger: 'blur'}
        ],
        message: [
          {
            required: true,
            message: this.language == 'zh' ? '请输入留言' : 'Please fill in your comments.',
            trigger: 'blur'
          }
        ],
      }
    },
  },
  data() {
    return {
      step: 1,
      labelPosition: "top",
      visible: false,
      firstPage: true,//显示第一页
      rows: 5,
      formLabelAlign: {
        name: "",
        tel: "",
        message: "",
        file: [],
      },
      action: "",
      loading: false,
    };
  },
  mounted() {
    this.action = this.baseURL + '/hdbs/api/files/upload'
    // this.init();
  },
  methods: {
    init() {
      this.visible = true;
      this.language = localStorage.getItem("language") || "zh";
      console.log('index language==' + this.language)
      this.$refs.ruleForm.resetFields()
      this.$forceUpdate();
      console.log("init");
    },
    submit() {
      if (this.formLabelAlign.name.trim().length === 0 || this.formLabelAlign.tel.trim().length === 0 || this.formLabelAlign.message.trim().length === 0) {
        this.$alert(this.language == 'zh' ? '请将带*的必填项填写完整后再提交, 谢谢!' : 'Please kindly fill in the required fileds, thanks!', this.language == 'zh' ? '提交失败' : 'Failed', {
          confirmButtonText: this.language == 'zh' ? '确定' : 'Back',
          center: true,
          callback: action => {

          }
        });
        return false;
      }
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.formLabelAlign.file = this.formLabelAlign.file.toString()
          this.$http
            .post("/hdbs/api/rfq/save",
              this.formLabelAlign
              , {
                headers: {
                  'Content-Type': 'application/json'
                }
              }
            )
            .then(
              function (response) {
                var status = response.data.code;
                if (status === 0) {
                  this.$alert(this.language == 'zh' ? '感谢咨询，我们将尽快与您联系！' : 'Thank you for your inquiry, we will contact you soon!', '', {
                    center: true,
                    confirmButtonText: this.language == 'zh' ? '确定' : 'Confirm',
                    callback: action => {
                      this.formLabelAlign = {
                        name: "",
                        tel: "",
                        message: "",
                        file: [],
                      }
                      this.visible = false
                    }
                  });
                }
              }.bind(this)
            )
        } else {
          console.log('error submit!!');
          return false;
        }
      });

    },
    onSuccess(response, file) {
      console.log(response)
      this.formLabelAlign.file.push(response.msg)
      this.loading = false;
    },
    onProgress(event, file, fileList) {
      this.loading = true;
    },
    onRemove() {
      this.formLabelAlign.file = []
    }
  },
};
</script>

<style lang="stylus" scoped>
.html_div {
  min-height: 50rem;
}

.title {
  color: var(--mainBlue);
  font-size: 3.2rem;
  font-family: Demibold;
  margin-bottom: 2rem;
}

/deep/ .el-form-item__label {
  color: var(--mainGary);
  font-size: 1.7rem;
  line-height: 1.5;
  padding: 0;
  font-family: Regular;
}

/deep/ .el-input__inner {
  background-color: var(--garyEF);
  border: none;
  color: var(--mainBlue);
  font-size: 1.7rem;
  font-family: Regular;
}

/deep/ .el-input__inner:hover {
  //background-color: #fff;
  //box-shadow: 0px 3px 12px rgba(0,0,0,0.12);
  //color:var(--mainGary);
  //border: 1px solid #EAEAEA
}

/deep/ .el-input__inner:focus {
  background-color: #fff;
  box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.12);
  color: var(--mainGary);
  //border: 1px solid #EAEAEA
}

/deep/ .el-textarea__inner {
  background-color: var(--garyEF);
  border: none;
  color: var(--mainBlue);
  font-size: 1.7rem;
  font-family: Regular;
}

/deep/ .el-textarea__inner:hover {
  //background-color: #fff;
  //box-shadow: 0px 3px 12px rgba(0,0,0,0.12);
  //color:var(--mainGary);
}

/deep/ .el-textarea__inner:focus {
  background-color: #fff;
  box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.12);
  color: var(--mainGary);
}

.jobBtn {
  padding: 0 1rem;
  font-family: Regular;
  font-size: 1.6rem;
  text-align: center;
  min-width: 13rem;
  width: auto;
  height: 4rem;
  cursor: pointer;
  margin: 0;
  color: #fff;
  background-color: var(--mainBlue);
  line-height: 4rem;
  border-radius: 6px;
  box-shadow: 6px 6px 12px rgba(0, 0, 0, 0.12);
}

/deep/ .el-dialog {
  border-radius: 6px;
  padding: 0 9rem;
}

.tip_big {
  word-break: keep-all;
}

.tip_small {
  font-size: 1.4rem;
}

@media screen and (max-width: 1200px) {
  /deep/ .el-dialog {
    padding: 0 1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AskDialog.vue